import slugify from "@sindresorhus/slugify";

const buildPageSlug = (pageSlugId: string, pageTitle?: string): string => {
  const titleSlug = slugify(pageTitle?.substring(0, 70) || "untitled", {
    customReplacements: [
      ["♥", ""],
      ["🦄", ""],
    ],
  });

  return `${titleSlug}-${pageSlugId}`;
};

export const buildPageUrl = (
  spaceName: string,
  pageSlugId: string,
  pageTitle?: string,
  anchorId?: string,
): string => {
  let url: string;
  if (spaceName === undefined) {
    url = `/p/${buildPageSlug(pageSlugId, pageTitle)}`;
  } else {
    url = `/s/${spaceName}/p/${buildPageSlug(pageSlugId, pageTitle)}`;
  }
  return anchorId ? `${url}#${anchorId}` : url;
};

export const buildPublicPageUrl = (
  spaceSlug: string | undefined,
  page: { publicSlug?: string | null; slugId?: string },
  anchorId?: string,
): string => {
  const segment = page.publicSlug || page.slugId || "";
  const base = spaceSlug
    ? `/docs/${spaceSlug}/${segment}`
    : `/docs/${segment}`;
  return anchorId ? `${base}#${anchorId}` : base;
};

export const slugifyAnchor = (text: string): string => {
  return (text || "")
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 80);
};

export const extractHeadingsFromContent = (
  content: any,
): { text: string; level: number; anchor: string }[] => {
  const out: { text: string; level: number; anchor: string }[] = [];
  const seen = new Map<string, number>();
  const nodes: any[] = Array.isArray(content)
    ? content
    : content && Array.isArray(content.content)
      ? content.content
      : [];
  for (const node of nodes) {
    if (!node || node.type !== "heading") continue;
    const level = Math.min(3, Math.max(1, Number(node.attrs?.level) || 1));
    const text = (node.content || [])
      .map((c: any) => (c?.type === "text" ? c.text || "" : ""))
      .join("")
      .trim();
    if (!text) continue;
    const base = slugifyAnchor(text);
    let anchor = base;
    const count = seen.get(base) ?? 0;
    if (count > 0) anchor = `${base}-${count + 1}`;
    seen.set(base, count + 1);
    out.push({ text, level, anchor });
  }
  return out;
};

export const buildSharedPageUrl = (opts: {
  shareId: string;
  pageSlugId: string;
  pageTitle?: string;
  anchorId?: string;
}): string => {
  const { shareId, pageSlugId, pageTitle, anchorId } = opts;
  let url: string;
  if (!shareId) {
    url = `/share/p/${buildPageSlug(pageSlugId, pageTitle)}`;
  } else {
    url = `/share/${shareId}/p/${buildPageSlug(pageSlugId, pageTitle)}`;
  }
  return anchorId ? `${url}#${anchorId}` : url;
};
